import { render, staticRenderFns } from "./workOrderTrainDetail.vue?vue&type=template&id=3f5f06ff&scoped=true"
import script from "./workOrderTrainDetail.vue?vue&type=script&lang=js"
export * from "./workOrderTrainDetail.vue?vue&type=script&lang=js"
import style0 from "./workOrderTrainDetail.vue?vue&type=style&index=0&id=3f5f06ff&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5f06ff",
  null
  
)

export default component.exports